<template>
    <v-window v-model="step">
        <v-window-item class="pb-5" :value="0">
            <v-form v-model="allConditionsCompleted" ref="form">
                <v-row no-gutters class="d-flex justify-center mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "La société" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companyName"
                            label="Nom du dossier"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            density="compact"
                            data-cy="bundle-company-name"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companySiret"
                            label="Siret"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companySiren"
                            label="Siren"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="apeCode"
                            label="Code APE"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companyStreetNumber"
                            label="Numéro de l'adresse"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companyStreetName"
                            label="Nom de voie"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companyPostalCode"
                            label="Code Postal"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companyCity"
                            label="Ville"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="socialReason"
                            label="Raison sociale"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="legalForm"
                            :label="$t('settings.legalForm')"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-select-filled
                            v-if="companyIncomeCategory === 'RF'"
                            :disabled="isSent"
                            outlined
                            v-model="bundleFixedVariables.C5"
                            :items="earningTypes"
                            item-title="text"
                            item-value="value"
                            hide-details="auto"
                            label="Type de revenus"
                            @update:model-value="emitManualChange()"
                            density="compact"
                            class="pl-2"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            v-if="companyIncomeCategory === 'BNC'"
                            disabled
                            v-model="companyActivity"
                            label="Nature de l'activité"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "Détails de la société" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-select-filled
                            disabled
                            outlined
                            v-model="companyIncomeCategory"
                            :items="incomeCategories"
                            item-title="name"
                            item-value="id"
                            hide-details="auto"
                            label="Catégorie de revenu"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-select-filled
                            disabled
                            outlined
                            class="pl-2"
                            v-model="companyTaxRegime"
                            :items="taxRegimes"
                            item-title="name"
                            item-value="id"
                            hide-details="auto"
                            label="Régime fiscal"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-select-filled
                            disabled
                            outlined
                            class="pl-2"
                            v-model="companyVatSystem"
                            :items="vatSystems"
                            item-title="name"
                            item-value="id"
                            hide-details="auto"
                            label="Régime TVA"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-select-filled
                            outlined
                            disabled
                            class="pl-2"
                            v-model="companyTaxSystemType"
                            :items="taxSystemTypes"
                            item-title="name"
                            item-value="id"
                            hide-details="auto"
                            label="Imposition"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companyStartBusinessDate"
                            label="Date de début d'activité"
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="companySalaryCount"
                            label="Nombre de salarié(s)"
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                    <v-col cols="3" />
                </v-row>
                <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "Responsable légal" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            v-if="!legalRepresentativeUsers.length"
                            :disabled="isSent"
                            v-model="bundleFixedVariables.legalRepresentative"
                            label="Nom du représentant légal"
                            required
                            outlined
                            hide-details="auto"
                            @change="emitManualChange()"
                            density="compact"
                        />
                        <v-select-filled
                            v-else
                            outlined
                            v-model="bundleFixedVariables.legalRepresentative"
                            :items="legalRepresentativeUsers"
                            item-title="text"
                            item-value="value"
                            hide-details="auto"
                            @update:model-value="
                                (emitManualChange(), onLegalRepresentativeChange())
                            "
                            label="Nom du représentant légal"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-select-filled
                            :disabled="isSent"
                            outlined
                            class="pl-2"
                            v-model="bundleFixedVariables.legalRepresentativeType"
                            :items="legalRepresentativeTypes"
                            item-title="text"
                            item-value="value"
                            hide-details="auto"
                            @update:model-value="emitManualChange()"
                            label="Qualité du responsable légal"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                    <v-col cols="3" />
                </v-row>
                <v-row no-gutters class="d-flex justify-center mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "La période" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingPeriodStart"
                            label="Date de début"
                            :rules="[rules.hasValueInMyExercices]"
                            required
                            outlined
                            hide-details="auto"
                            density="compact"
                            data-cy="bundle-accounting-period-start"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingPeriodEnd"
                            label="Date de fin"
                            :rules="[rules.hasValueInMyExercices]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                            data-cy="bundle-accounting-period-end"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingPeriodLength"
                            label="Durée (en mois)"
                            :rules="[rules.hasValueInMyExercices]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            :disabled="!!previousAccountingPeriod"
                            v-model="variables.previousAccPeriod.start"
                            label="Date de début de la période précédente"
                            @change="emitManualChange()"
                            outlined
                            hide-details="auto"
                            density="compact"
                            v-if="!isStartBusinessDate"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            :disabled="!!previousAccountingPeriod"
                            v-model="variables.previousAccPeriod.end"
                            label="Date de fin de la période précédente"
                            @change="emitManualChange()"
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            :disabled="!!previousAccountingPeriod"
                            v-model="variables.previousAccPeriod.duration"
                            label="Durée (en mois) de la période précédente"
                            @change="emitManualChange()"
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                </v-row>
                <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "Codes ROF" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="rofIScode"
                            label="Impôts sur les sociétés"
                            outlined
                            :prefix="rofISprefix"
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="rofCVAEcode"
                            label="CVAE"
                            outlined
                            :prefix="rofCVAEprefix"
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="rofBundleCode"
                            label="Liasse fiscale"
                            outlined
                            :prefix="rofBundlePrefix"
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                </v-row>
                <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "OGA" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3" class="d-flex justify-center align-center">
                        <v-switch v-model="ogaEnrolment" hide-details disabled />
                        <v-text-field-filled
                            disabled
                            v-model="ogaEnrolmentNumberId"
                            label="Numéro d'identification"
                            outlined
                            hide-details="auto"
                            density="compact"
                            class="pl-2"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="ogaEnrolmentYear"
                            label="Année"
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="ogaEnrolmentSiret"
                            label="SIRET"
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="ogaEnrolmentDesignation"
                            label="Désignation"
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="ogaEnrolmentAddress"
                            label="Adresse"
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="ogaEnrolmentPostalCode"
                            label="Code postal"
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="ogaEnrolmentCity"
                            label="Ville"
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "Informations complémentaires" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            :disabled="isSent"
                            v-model="bundleFixedVariables.V2"
                            label="Date de cessation"
                            required
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            :disabled="isSent"
                            v-model="bundleFixedVariables.Y6"
                            label="Date de dépôt provisoire"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                    <v-col cols="3" />
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-checkbox
                            disabled
                            v-model="bundleFixedVariables.C1"
                            true-value="Oui"
                            false-value="Non"
                            label="Comptabilité informatisée"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-checkbox disabled v-model="companySubjectToVAT" label="Soumis à TVA" />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="bundleFixedVariables.C2"
                            label="Nom du logiciel utilisé"
                            :rules="[rules.hasValue]"
                            v-if="variables.isComputerizedAccounting"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                </v-row>
                <v-divider />
                <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "Le cabinet" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingFirmName"
                            label="Nom du cabinet"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingFirmSiret"
                            label="Siret cabinet"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingFirmSiren"
                            label="Siren cabinet"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingFirmApeCode"
                            label="Code APE cabinet"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingFirmSocialReason"
                            label="Raison sociale cabinet"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingFirmAddress"
                            label="Adresse cabinet"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingFirmPostalCode"
                            label="Code Postal cabinet"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            disabled
                            v-model="accountingFirmCity"
                            label="Ville cabinet"
                            :rules="[rules.hasValueInMyFile]"
                            required
                            outlined
                            hide-details="auto"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters class="mt-5">
                    <v-col cols="12">
                        <h4 class="ml-5">{{ "Le signataire" }}</h4>
                    </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                    <v-col cols="3">
                        <v-select-filled
                            v-model="bundleFixedVariables.Y1"
                            :items="accountingSignatories"
                            item-title="text"
                            item-value="value"
                            :rules="[rules.hasValue]"
                            required
                            :disabled="isSent"
                            outlined
                            hide-details="auto"
                            @update:model-value="emitManualChange()"
                            label="Nom complet du signataire"
                            density="compact"
                            :clearable="!isSent"
                            @click:clear="bundleFixedVariables.Y1 = null"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            :disabled="isSent"
                            v-model="bundleFixedVariables.Y2"
                            label="Qualité du signataire"
                            :rules="[rules.hasValue]"
                            required
                            outlined
                            hide-details="auto"
                            @change="emitManualChange()"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3">
                        <v-text-field-filled
                            :disabled="isSent"
                            v-model="bundleFixedVariables.signatureCity"
                            label="Lieu de la signature"
                            :rules="[rules.hasValue]"
                            required
                            outlined
                            hide-details="auto"
                            @change="emitManualChange()"
                            class="pl-2"
                            density="compact"
                        />
                    </v-col>
                    <v-col cols="3" />
                </v-row>
                <template
                    v-if="
                        companyDetails && companyDetails.shareCapital && companyDetails.shareTotal
                    "
                >
                    <v-row no-gutters class="mt-5">
                        <v-col cols="12">
                            <h4 class="ml-5">{{ "Juridique" }}</h4>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                        <v-col cols="12">
                            <AssociatesTable
                                :company="companyDetails"
                                @shareQuantityDifferenceIsOverZero="
                                    $emit('shareQuantityDifferenceIsOverZero')
                                "
                            />
                        </v-col>
                    </v-row>
                </template>
                <template v-if="isSCI">
                    <v-row no-gutters class="mt-5">
                        <v-col cols="12">
                            <h4 class="ml-5">{{ "Immeubles" }}</h4>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="d-flex justify-center align-center px-2 py-1">
                        <v-col cols="12">
                            <BuildingsTable :company="companyDetails" />
                        </v-col>
                    </v-row>
                </template>
            </v-form>
        </v-window-item>
        <v-window-item class="pb-5" value="selectUser">
            <v-row no-gutters>
                <v-col cols="12">
                    <selectUser
                        class="px-1"
                        v-model="signerUser"
                        :companyId="companyId"
                        :type="'NATURAL_PERSON'"
                        :withEmail="true"
                    />
                </v-col>
            </v-row>
        </v-window-item>
    </v-window>
</template>

<script lang="ts">
import _ from "lodash";
import moment from "moment-timezone";
import gql from "graphql-tag";
import { User } from "@/store/store";
import { Apollo } from "@/decorators";
import { IncomeCategories, TaxRegimes, TaxSystemsTypes } from "../../../types/tax/taxSystems.types";
import { getUserDisplayName } from "@/services/userServices";
import { Component, Vue, Prop, Model, toNative, Watch } from "vue-facing-decorator";
import { FormSelectOption } from "../../../types/formSelectOption.types";
import { CompanyVatSystem, getVATSystem, isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import COMPANY_USERS from "../../../graphql/user/PartOfCompanyUsers2.gql";
import BuildingsTable from "../../BuildingsTable.vue";
import AssociatesTable from "../../user/AssociatesTable.vue";
import SelectUser from "../../user/SelectUser.vue";
import { getIncomeCategoriesByTaxRegime, getTaxRegimesByIncomeCategory } from "@/services/taxIncomeFilterServices";
import { getAccountingPeriodLength } from "../../../../../backend/src/common/bundle/BundleBase";


@Component({
    components: {
        SelectUser,
        AssociatesTable,
        BuildingsTable,
    },
    emits: ["variablesUpdated", "variablesFetched", "shareQuantityDifferenceIsOverZero"],
})
export class BundleDetails extends Vue {
    @Model({ default: false }) value: boolean;
    @Prop({ default: null }) bundleId: string;
    @Prop({ default: false }) isSent: boolean;

    step = "0";

    allConditionsCompleted = false;

    allIncomeCategories: FormSelectOption[] = IncomeCategories;

    allTaxRegimes: FormSelectOption[] = TaxRegimes;

    vatSystems: Array<FormSelectOption> = [
        { id: CompanyVatSystem.NotSubjectTo, name: getVATSystem(CompanyVatSystem.NotSubjectTo) },
        {
            id: CompanyVatSystem.BelowTheThreshold,
            name: getVATSystem(CompanyVatSystem.BelowTheThreshold),
        },
        { id: CompanyVatSystem.Normal, name: getVATSystem(CompanyVatSystem.Normal) },
        { id: CompanyVatSystem.Quartely, name: getVATSystem(CompanyVatSystem.Quartely) },
        { id: CompanyVatSystem.Simplified, name: getVATSystem(CompanyVatSystem.Simplified) },
        {
            id: CompanyVatSystem.SimplifiedExercise,
            name: getVATSystem(CompanyVatSystem.SimplifiedExercise),
        },
        {
            id: CompanyVatSystem.FlatRateRefund,
            name: getVATSystem(CompanyVatSystem.FlatRateRefund),
        },
    ];

    taxSystemTypes: FormSelectOption[] = TaxSystemsTypes;

    legalRepresentativeTypes: any = [
        { text: "Sans qualité", value: null },
        { text: "Chef d'entreprise", value: "CEO" },
        { text: "Gérant", value: "MANAGING_DIRECTOR" },
        { text: "Président", value: "PRESIDENT" },
        { text: "Directeur", value: "SUPERVISOR" },
        { text: "Directeur général", value: "GENERAL_SUPERVISOR" },
    ];

    earningTypes: Array<{ text: string; value: string }> = [
        { text: "BIC IS", value: "1" },
        { text: "BA", value: "0" },
    ];

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get rules() {
        return {
            hasValue: (value) => {
                return !!value || "A remplir";
            },
            hasValueInMyFile: (value) => {
                return !!value || "A remplir dans 'Mon Dossier'";
            },
            hasValueInMyExercices: (value) => {
                return !!value || "A remplir dans 'Mon Dossier -> Exercices'";
            },
            isDate: (value) => {
                if (/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(value)) {
                    return true;
                }
                return "Format accepté : JJ/MM/AAAA";
            },
            isNumber: (value) => {
                if (/^[0-9]*$/.test(value)) {
                    return true;
                }
                return "Seuls les nombres sont acceptés";
            },
        };
    }

    get isValid() {
        if (
            this.step === "0" &&
            this.nbVariablesCompleted === this.nbVariablesToComplete &&
            this.allConditionsCompleted
        ) {
            return true;
        }
        return true; // A REMETTRE A FALSE !!!
    }

    get selectedCompany() {
        return this.$store?.state.selected_company;
    }

    get selectedAccountingPeriod() {
        return this.$store?.state.accountingPeriod.selectedAccountingPeriod;
    }

    get previousAccountingPeriod() {
        if (
            this.$store?.state.accountingPeriod.accountingPeriods?.length > 1 &&
            this.selectedAccountingPeriod
        ) {
            const indexAccPeriod = this.$store?.state.accountingPeriod.accountingPeriods.findIndex(
                (e) => e.id === this.selectedAccountingPeriod.id,
            );
            if (indexAccPeriod > 0) {
                return this.$store?.state.accountingPeriod.accountingPeriods[indexAccPeriod - 1];
            }
        }
        return undefined;
    }

    get currentUser(): User {
        const user: User = this.$store?.state?.user;
        if (this.bundleFixedVariables && !this.bundleFixedVariables.signatureCity) {
            this.bundleFixedVariables.signatureCity = user?.company?.city;
        }
        return user;
    }

    get companyId() {
        return this.currentUser.company.id;
    }

    get signerUser() {
        return this.variables.signer.user;
    }

    set signerUser(value) {
        this.variables.signer.user = value;
        this.step = "0";
    }

    get isStartBusinessDate() {
        if (
            this.companyDetails &&
            this.selectedAccountingPeriod &&
            this.selectedAccountingPeriod.start === this.companyDetails.startBusinessDate
        ) {
            return true;
        }
        return false;
    }

    get nbVariablesToComplete() {
        let result = 16;
        if (!this.isStartBusinessDate) {
            result += 3;
        }
        if (this.variables.isComputerizedAccounting) {
            result++;
        }
        // complete with stoppingDate and temporaryDepositDate
        return result;
    }

    get nbVariablesCompleted() {
        let result = 0;
        if (this.companyName) {
            result++;
        }
        if (this.accountingPeriodEnd) {
            result++;
        }
        if (this.variables.previousAccPeriod.end) {
            result++;
        }
        if (this.accountingPeriodLength) {
            result++;
        }
        if (this.variables.previousAccPeriod.duration) {
            result++;
        }
        if (this.companyStreetNumber) {
            result++;
        }
        if (this.companyStreetName) {
            result++;
        }
        if (this.companyCity) {
            result++;
        }
        if (this.variables.previousAccPeriod.start) {
            result++;
        }
        if (this.accountingPeriodStart) {
            result++;
        }
        if (this.companyPostalCode) {
            result++;
        }
        if (this.companySiret) {
            result++;
        }
        if (this.companySiren) {
            result++;
        }
        if (this.apeCode) {
            result++;
        }
        if (this.socialReason) {
            result++;
        }
        if (this.variables?.millesim) {
            result++;
        }
        if (this.stoppingDate) {
            result++;
        }
        if (this.temporaryDepositDate) {
            result++;
        }
        if (this.variables?.signer?.user) {
            result++;
        }
        if (this.variables?.signer?.quality) {
            result++;
        }
        if (this.variables?.signer?.city) {
            result++;
        }
        if (this.variables?.accountingSoftware) {
            result++;
        }
        return result;
    }

    get result() {
        return {
            fixedVariables: {
                Z0: this.bundleFixedVariables.Z0 || this.companyName,
                Z1: this.bundleFixedVariables.Z1 || this.accountingPeriodEnd,
                Z2: this.bundleFixedVariables.Z2 || this.variables?.previousAccPeriod?.end,
                Z3: this.bundleFixedVariables.Z3 || this.accountingPeriodLength,
                Z4: this.bundleFixedVariables.Z4 || this.variables?.previousAccPeriod?.duration,
                Z5: this.bundleFixedVariables.Z5 || this.companyStreetNumber,
                Z6: this.bundleFixedVariables.Z6 || this.companyStreetName,
                Z8: this.bundleFixedVariables.Z8 || this.companyCity,
                Z7: this.bundleFixedVariables.Z7 || this.variables?.previousAccPeriod?.start,
                Z9: this.bundleFixedVariables.Z9 || this.accountingPeriodStart,
                Y0: this.bundleFixedVariables.Y0 || this.companyPostalCode,
                X0: this.bundleFixedVariables.X0 || this.companySiret,
                X5: this.bundleFixedVariables.X5 || this.companySiren,
                X1: this.bundleFixedVariables.X1 || this.apeCode,
                W2: this.bundleFixedVariables.W2 || this.socialReason,
                V6: this.bundleFixedVariables.V6 || this.variables?.millesim,
                V2: this.bundleFixedVariables.V2 || this.stoppingDate,
                Y6: this.bundleFixedVariables.Y6 || this.temporaryDepositDate,
                Y1: this.bundleFixedVariables.Y1 || this.accountingSignatory,
                Y2: this.bundleFixedVariables.Y2 || this.variables?.signer?.quality,
                signatureCity:
                    this.bundleFixedVariables.signatureCity || this.currentUser?.company?.city,
                C1: this.bundleFixedVariables.C1 || this.variables?.isComputerizedAccounting,
                C2: this.bundleFixedVariables.C2 || this.variables?.accountingSoftware,
                C4: this.bundleFixedVariables.C4 || this.companySubjectToVAT,
                C5: this.bundleFixedVariables.C5,
                legalRepresentative: this.bundleFixedVariables.legalRepresentative,
                legalRepresentativeType: this.bundleFixedVariables.legalRepresentativeType,
                W0:
                    this.bundleFixedVariables.W0 ||
                    (this.companyIncomeCategory === "BIC" &&
                        this.companyTaxRegime === "REAL_NORMAL")
                        ? "X"
                        : "",
                W1:
                    this.bundleFixedVariables.W1 ||
                    (this.companyIncomeCategory === "BIC" &&
                        this.companyTaxRegime === "REAL_SIMPLIFIED")
                        ? "X"
                        : "",
            },
        };
    }

    get companyName() {
        return this.selectedCompany?.name || null;
    }

    get accountingPeriodEnd() {
        if (this.selectedAccountingPeriod?.end) {
            return moment(this.selectedAccountingPeriod.end).format("DD/MM/YYYY");
        }
        return null;
    }

    get previousAccountingPeriodEnd() {
        if (this.previousAccountingPeriod?.end) {
            return moment(this.previousAccountingPeriod.end).format("DD/MM/YYYY");
        }
        return null;
    }

    get accountingPeriodLength() {
        return getAccountingPeriodLength(this.selectedAccountingPeriod) || 0;
    }

    get previousAccountingPeriodLength() {
        const start = this.previousAccountingPeriod?.start || undefined;
        const end: string = this.previousAccountingPeriod?.end || undefined;
        if (start && end) {
            return Math.round(moment(end).diff(moment(start), "months", true));
        }
        return null;
    }

    get companyStreetNumber() {
        if (this.companyDetails?.address) {
            // const [number, ...rest] = this.companyDetails.address.toLowerCase().split(/(^[0-9]* (bis|ter|quater|))/g) //pas compris pourquoi ça ne fonctionne pas
            let [number, ...rest] = this.companyDetails.address.split(" "); // permet d'intégrer les adresses comme '12-14 rue de ...'
            if (number && rest?.length) {
                if (["bis", "ter", "quater"].includes(rest[0].toLowerCase())) {
                    number += " " + rest[0];
                }
                return number;
            }
        }
        return null;
    }

    get companyStreetName() {
        if (this.companyDetails?.address) {
            // const [number, rest] = this.companyDetails.address.split(' ')
            // return rest.join(' ')
            const result = this.companyDetails.address.replace(this.companyStreetNumber + " ", "");
            return result;
        }
        return null;
    }

    get companyCity() {
        return this.companyDetails?.city || null;
    }

    get companySalaryCount() {
        return this.companyDetails?.salaryCount || null;
    }

    get companyIncomeCategory(): "ASSOC" | "BA" | "BIC" | "BNC" | "RF" {
        return this.companyDetails?.incomeCategory || null;
    }

    get companyTaxRegime() {
        return this.companyDetails?.taxRegime || null;
    }

    get companyVatSystem() {
        return this.companyDetails?.vatSystem || null;
    }

    get companyTaxSystemType() {
        return this.companyDetails?.taxSystemType || null;
    }

    get companyStartBusinessDate() {
        if (this.companyDetails?.startBusinessDate) {
            return moment(this.companyDetails.startBusinessDate).format("DD/MM/YYYY");
        }
        return null;
    }

    get companyUsers() {
        if (this.companyDetails?.companyUsers?.length) {
            return this.companyDetails.companyUsers;
        }
        return null;
    }

    get legalRepresentativeUsers() {
        if (this.companyUsers) {
            return this.companyUsers
                .filter((user) => user.accountingLegalRepresentative === true)
                .map((user) => ({
                    value: user.user.id,
                    text: getUserDisplayName(user.user),
                }));
        }
        return [];
    }

    get rofs() {
        if (this.companyDetails?.profile?.rofs?.length) {
            return this.companyDetails?.profile?.rofs;
        }
        return null;
    }

    get rofIScode() {
        return this.rofs?.find((rof) => rof.tax === "IS")?.code || null;
    }

    get rofISprefix() {
        return this.rofs?.find((rof) => rof.tax === "IS")?.prefix || null;
    }

    get rofCVAEcode() {
        return this.rofs?.find((rof) => rof.tax === "CVAE")?.code || null;
    }

    get rofCVAEprefix() {
        return this.rofs?.find((rof) => rof.tax === "CVAE")?.prefix || null;
    }

    get rofBundleCode() {
        return this.rofs?.find((rof) => rof.tax === "Liasse")?.code || null;
    }

    get rofBundlePrefix() {
        return this.rofs?.find((rof) => rof.tax === "Liasse")?.prefix || null;
    }

    get companySubjectToVAT() {
        return !isNotSubjectToVAT(this.companyDetails?.vatSystem) || null;
    }

    get previousAccountingPeriodStart() {
        if (this.previousAccountingPeriod?.start) {
            return moment(this.previousAccountingPeriod.start).format("DD/MM/YYYY");
        }
        return null;
    }

    get accountingPeriodStart() {
        if (this.selectedAccountingPeriod?.start) {
            return moment(this.selectedAccountingPeriod.start).format("DD/MM/YYYY");
        }
        return null;
    }

    get companyPostalCode() {
        return this.companyDetails?.postalCode || null;
    }

    get companySiret() {
        return this.companyDetails?.siret || null;
    }

    get companySiren() {
        return this.companyDetails?.siren || null;
    }

    get apeCode() {
        // first activity is the main activity (the only one used for taxForm)
        if (this.companyDetails?.activities?.[0]?.name) {
            return (
                this.companyDetails.activities[0].name +
                " - " +
                this.companyDetails.activities[0].description
            );
        }
        return null;
    }

    get socialReason() {
        return this.companyName;
    }

    get stoppingDate() {
        return null;
    }

    get temporaryDepositDate() {
        return null;
    }

    get temporaryLegalRepresentative() {
        return null;
    }

    get accountingFirmId() {
        return this.currentUser?.company?.id || null;
    }

    get accountingFirmName() {
        return this.currentUser?.company?.name || null;
    }

    get accountingFirmSiret() {
        return this.currentUser?.company?.siret || null;
    }

    get accountingFirmSiren() {
        return this.currentUser?.company?.siren || null;
    }

    get accountingFirmApeCode() {
        if (this.currentUser?.company?.activities?.[0]?.name) {
            return (
                this.currentUser.company.activities[0].name +
                " - " +
                this.currentUser.company.activities[0].description
            );
        }
        return null;
    }

    get accountingFirmSocialReason() {
        return this.accountingFirmName || null;
    }

    get accountingFirmAddress() {
        return this.currentUser?.company?.address || null;
    }

    get accountingFirmPostalCode() {
        return this.currentUser?.company?.postalCode || null;
    }

    get accountingFirmCity() {
        return this.currentUser?.company?.city || null;
    }

    get isBNC() {
        return this.companyDetails?.incomeCategory === "BNC";
    }

    get isSCI() {
        return this.companyDetails?.legalForm === "SCI";
    }

    get ogaEnrolment() {
        return this.companyDetails?.profile?.ogaEnrolment || null;
    }

    get ogaEnrolmentNumberId() {
        return this.companyDetails?.profile?.ogaEnrolmentConfig?.numberId || null;
    }

    get ogaEnrolmentYear() {
        return this.companyDetails?.profile?.ogaEnrolmentConfig?.year || null;
    }

    get ogaEnrolmentSiret() {
        return this.companyDetails?.profile?.ogaEnrolmentConfig?.siret || null;
    }

    get ogaEnrolmentDesignation() {
        return this.companyDetails?.profile?.ogaEnrolmentConfig?.designation || null;
    }

    get ogaEnrolmentAddress() {
        return this.companyDetails?.profile?.ogaEnrolmentConfig?.address || null;
    }

    get ogaEnrolmentPostalCode() {
        return this.companyDetails?.profile?.ogaEnrolmentConfig?.postalCode || null;
    }

    get ogaEnrolmentCity() {
        return this.companyDetails?.profile?.ogaEnrolmentConfig?.city || null;
    }

    get legalForm() {
        const legalForms = [
            { id: "ASSO", name: "Association" },
            { id: "CE", name: "Comité d'entreprise" },
            { id: "CL", name: "Collectivité locale" },
            { id: "CNE", name: "Commune" },
            { id: "COOP", name: "Coopérative" },
            { id: "CUMA", name: "Coopérative d'utilisation de matériel agricole" },
            { id: "DPT", name: "Département" },
            { id: "EARL", name: "Exploitation agricole à responsabilité limitée" },
            { id: "EC", name: "Entreprise collective" },
            { id: "EI", name: "Entreprise individuelle" },
            { id: "EIRL", name: "Entreprise individuelle à responsabilité limitée" },
            { id: "ETRANGER", name: "Personne morale de droit étranger" },
            { id: "EURL", name: "Entreprise unipersonnelle à responsabilité limitée" },
            { id: "FEDE", name: "Fédération" },
            { id: "FOND", name: "Fondation" },
            { id: "GAEC", name: "Groupement agricole d'exploitation en commun" },
            { id: "GEIE", name: "Groupement européen d'intérêt économique" },
            { id: "GF", name: "Groupement forestier" },
            { id: "GFA", name: "Groupement foncier agricole" },
            { id: "GFR", name: "Groupement foncier rural" },
            { id: "GIE", name: "Groupement d'intérêt économique" },
            { id: "GPT", name: "Groupement" },
            { id: "GREFFE", name: "Greffe" },
            { id: "IND", name: "Indivision" },
            { id: "MUT", name: "Mutuelle" },
            { id: "SA", name: "Société anonyme" },
            { id: "SAE", name: "Société anonyme d'exploitation" },
            { id: "SARL", name: "Société à responsabilité limitée" },
            { id: "SELARL", name: "Société d'exercice libéral à responsabilité limitée" },
            { id: "SAS", name: "Société anonyme par actions simplifiée" },
            { id: "SASU", name: "SASU" },
            { id: "SC", name: "Société civile (autre que infra)" },
            { id: "SCA", name: "Société en commandite par actions" },
            { id: "SCCV", name: "Société civile de construction vente" },
            { id: "SCE", name: "Société civile d'exploitation" },
            { id: "SCEA", name: "Société civile d'exploitation agricole" },
            { id: "SCEV", name: "Société civile d'exploitation vinicole" },
            { id: "SCH", name: "Société civile holding" },
            { id: "SCI", name: "Société civile immobilière" },
            { id: "SCM", name: "Société civile de moyens" },
            { id: "SCP", name: "Société civile professionnelle" },
            { id: "SCPG", name: "Société civile participation gestion" },
            { id: "SCPI", name: "Société civile de placement collectif immobilier" },
            { id: "SCS", name: "Société en commandite simple" },
            { id: "SCVV", name: "Société civile de vente volontaire" },
            { id: "SDE", name: "Société de droit étranger" },
            { id: "SNC", name: "Société en nom collectif" },
        ];

        if (this.companyDetails?.legalForm) {
            const legalForm = legalForms.find((form) => form.id === this.companyDetails.legalForm);
            return legalForm?.name || null;
        }
        return null;
    }

    get companyActivity() {
        return this.companyDetails?.activities?.[0]?.description || "";
    }

    get accountingSignatory() {
        let accountingSignatory = null;
        if (this.$store?.state && this.$store?.state.accountingFirmClient) {
            if (this.$store?.state.accountingFirmClient.accountingSignatory) {
                if (
                    this.$store?.state.accountingFirmClient.accountingSignatory.firstname &&
                    this.$store?.state.accountingFirmClient.accountingSignatory.lastname
                )
                    accountingSignatory =
                        this.$store?.state.accountingFirmClient.accountingSignatory.firstname +
                        " " +
                        this.$store?.state.accountingFirmClient.accountingSignatory.lastname;
            }
        }
        if (this.bundleFixedVariables && !this.bundleFixedVariables.accountingSignatory) {
            this.bundleFixedVariables.Y1 = accountingSignatory;
        }
        return accountingSignatory;
    }

    get incomeCategories() {
        return getIncomeCategoriesByTaxRegime(
        this.allIncomeCategories,
        this.companyDetails?.taxRegime
        )
    }

    get taxRegimes() {
        return getTaxRegimesByIncomeCategory(
        this.allTaxRegimes,
        this.companyDetails?.incomeCategory
        )
    }

    @Watch('companyDetails.incomeCategory')
    onIncomeCategoryChange() {
        if (
        this.companyDetails?.taxRegime &&
        !this.taxRegimes.find(tax => tax.id === this.companyDetails?.taxRegime)
        ) {
        this.companyDetails.taxRegime = null
        }
    }

    @Watch('companyDetails.taxRegime')
    onTaxRegimeChange() {
        if (
        this.companyDetails?.incomeCategory &&
        !this.incomeCategories.find(income => income.id === this.companyDetails?.incomeCategory)
        ) {
        this.companyDetails.incomeCategory = null
        }
    }

    beforeMount() {
        this.variables.previousAccPeriod.start = this.previousAccountingPeriodStart;
        this.variables.previousAccPeriod.end = this.previousAccountingPeriodEnd;
        this.variables.previousAccPeriod.duration = this.previousAccountingPeriodLength;
        // if (!this.bundleId) {
        //     this.variables.signer.user = JSON.parse(JSON.stringify(this.currentUser))
        // }
        // if (this.$refs?.form?.validate()) {
        // }
        // this.$emit('variablesUpdated', this.result)
    }

    emitManualChange() {
        this.$emit("variablesUpdated", this.result);
    }

    onLegalRepresentativeChange() {
        if (this.bundleFixedVariables.legalRepresentative) {
            this.variables.legalRepresentative = this.bundleFixedVariables.legalRepresentative;
            const companyUserLegalRepresentativeType = this.companyUsers?.find(
                (user) => user.user.id === this.variables.legalRepresentative,
            )?.legalRepresentativeType;
            if (companyUserLegalRepresentativeType) {
                this.bundleFixedVariables.legalRepresentativeType =
                    companyUserLegalRepresentativeType;
                this.variables.legalRepresentativeType = companyUserLegalRepresentativeType;
                this.emitManualChange();
            }
        }
    }

    @Apollo({
        query: gql`
            query CompanyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    address
                    postalCode
                    city
                    country
                    startBusinessDate
                    firstAccountingPeriodEnd
                    taxSystem
                    taxSystemType
                    subjectToVAT
                    vatSystem
                    salaryCount
                    legalForm
                    shareTotal
                    siren
                    siret
                    shareCapital
                    buildings
                    profile {
                        id
                        ogaEnrolment
                        ogaEnrolmentConfig
                        rofs
                    }
                    companyUsers {
                        id
                        user {
                            id
                            firstname
                            lastname
                            email
                            type
                        }
                        investment
                        accountingLegalRepresentative
                        legalRepresentativeType
                    }
                    activities {
                        id
                        name
                        description
                    }
                    incomeCategory
                    taxRegime
                }
            }
        `,
        variables() {
            return {
                id: this.selectedCompany.id,
            };
        },
        skip() {
            return !this.selectedCompany;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.company) {
                    this.companyDetails = data.company;
                } else {
                    this.companyDetails = null;
                }
                this.$emit("variablesUpdated", this.result);
            }
        },
    })
    companyDetails: any = null;

    @Apollo({
        query: gql`
            query bundle($id: ID!) {
                declaration(where: { id: $id }) {
                    data
                }
            }
        `,
        variables() {
            return {
                id: this.bundleId,
            };
        },
        skip() {
            return !this.selectedCompany || !this.bundleId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.declaration?.data?.fixedVariables) {
                    this.bundleFixedVariables = data.declaration.data.fixedVariables;
                    if (this.bundleFixedVariables?.Z2) {
                        this.variables.previousAccPeriod.end = this.bundleFixedVariables.Z2;
                    }
                    if (this.bundleFixedVariables?.Z4) {
                        this.variables.previousAccPeriod.duration = this.bundleFixedVariables.Z4;
                    }
                    if (this.bundleFixedVariables?.Z7) {
                        this.variables.previousAccPeriod.start = this.bundleFixedVariables.Z7;
                    }
                    if (this.bundleFixedVariables?.V6) {
                        this.variables.millesim = this.bundleFixedVariables.V6;
                    }
                    if (this.bundleFixedVariables?.Y2) {
                        this.variables.signer.quality = this.bundleFixedVariables.Y2;
                    }
                    if (this.bundleFixedVariables?.signatureCity) {
                        this.variables.signer.city = this.bundleFixedVariables.signatureCity;
                    }
                    if (this.bundleFixedVariables?.C2) {
                        this.variables.accountingSoftware = this.bundleFixedVariables.C2;
                    }
                    if (this.bundleFixedVariables?.C1) {
                        this.variables.isComputerizedAccounting = this.bundleFixedVariables.C1;
                    }
                    if (this.bundleFixedVariables?.legalRepresentative) {
                        this.variables.legalRepresentative =
                            this.bundleFixedVariables.legalRepresentative;
                    }
                    if (this.bundleFixedVariables?.legalRepresentativeType) {
                        this.variables.legalRepresentativeType =
                            this.bundleFixedVariables.legalRepresentativeType;
                    }
                    this.$emit("variablesFetched", this.result);
                } else {
                    this.$emit("variablesUpdated", this.result);
                }
            }
        },
    })
    variables = {
        previousAccPeriod: { start: null, end: null, duration: null },
        millesim: "",
        signer: { user: null, quality: "Expert Comptable", city: "" },
        isComputerizedAccounting: "Oui",
        accountingSoftware: "bobbee",
        legalRepresentative: "",
        legalRepresentativeType: "",
    };

    @Apollo({
        query: COMPANY_USERS,
        variables() {
            return {
                companyId: this.accountingFirmId,
                email_not: null,
            };
        },
        skip() {
            return !this.accountingFirmId;
        },
        specificResult({ data, loading }: any) {
            if (!loading) {
                if (data && data.users) {
                    const accountingSignatories = [];
                    data.users.forEach((user) => {
                        accountingSignatories.push({
                            value: user.id,
                            text: getUserDisplayName(user),
                        });
                    });
                    accountingSignatories.sort((a, b) => {
                        if (a.key < b.key) return -1;
                        if (a.key > b.key) return 1;
                        return 0;
                    });
                    this.accountingSignatories = accountingSignatories;
                }
            }
        },
    })
    accountingSignatories: Array<any> = [];

    bundleFixedVariables: any = {
        Z0: this.companyName,
        Z1: this.accountingPeriodEnd,
        Z2: this.variables?.previousAccPeriod?.end,
        Z3: this.accountingPeriodLength,
        Z4: this.variables?.previousAccPeriod?.duration,
        Z5: this.companyStreetNumber,
        Z6: this.companyStreetName,
        Z8: this.companyCity,
        Z7: this.variables?.previousAccPeriod?.start,
        Z9: this.accountingPeriodStart,
        Y0: this.companyPostalCode,
        X0: this.companySiret,
        X5: this.companySiren,
        X1: this.apeCode,
        W2: this.socialReason,
        V6: this.variables?.millesim,
        V2: this.stoppingDate,
        Y6: this.temporaryDepositDate,
        Y1: this.accountingSignatory,
        Y2: this.variables?.signer?.quality,
        signatureCity: this.currentUser?.company?.city,
        C2: this.variables?.accountingSoftware,
        C1: this.variables?.isComputerizedAccounting,
        C4: this.companySubjectToVAT,
        C5: null,
        legalRepresentative: this.temporaryLegalRepresentative,
        legalRepresentativeType: null,
        W0:
            this.companyIncomeCategory === "BIC" && this.companyTaxRegime === "REAL_NORMAL"
                ? "X"
                : "",
        W1:
            this.companyIncomeCategory === "BIC" && this.companyTaxRegime === "REAL_SIMPLIFIED"
                ? "X"
                : "",
    };

    displayDateTime(date) {
        return moment(date).format("DD/MM/YYYY");
    }

    previous() {
        if (this.step !== "0") {
            this.step = (parseInt(this.step) - 1).toString();
        }
    }

    valid() {
        // no longer used
        this.step = (parseInt(this.step) + 1).toString();
    }

    // openTaxForm() {
    //     this.$router.push({
    //         name:"declaration-new"
    //     })
    // }
}

export default toNative(BundleDetails);
</script>
